<template>
  <div :key="analysisType.id">
    <router-view />
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
    computed: {
        ...mapGetters([
            'analysisType',
        ]),
    },
    async beforeRouteUpdate(to, from, next) {
        if (from.params.analysisTypeId !== to.params.analysisTypeId) {
            if (await this.getAnalysisTypeInfo(to.params.analysisTypeId)) {
                next();
            }
        } else {
            next();
        }
    },
    methods: {
        ...mapActions({
            getAnalysisTypeInfo: 'getAnalysisTypeInfo',
        }),
    },
};
</script>
